<template>
    <div>
       <modal 
       name="cancelMeetingModal" 
       classes="v-modal-sec"
       :min-width="200"
       :min-height="200"
       :scrollable="true"
       :reset="true"
       width="500px"
       height="auto"> 
       <div class="v-modal">
           <div class="popup-header fromDetailsPage">
               <h2 class="popup-title">Cancel Meeting</h2>
               <span @click="hideMe()">
               <em class="material-icons">close</em>
               </span>
           </div>
           <form @submit.prevent data-vv-scope="meetingForm" @click="meetingErr= ''" >
               <div class="form-container" @click="meetingErr=''">
                   <div class="vx-col  w-full ">
                     <div class="form_group">
                         <quillTextEditor :wrapclass="'form_group'" :fieldName="'cancelMeatingReason'" :required="true"  :cid="'cancelMeatingReason'"
                         :customValidNotRequire="false" v-model="cancelMeatingReason" :canSpellCheck="true" label="Reason" 
                         placeHolder="Reason" :vvas="'Reason'" :formscope="'meetingForm'"
                         />
                     </div>
                   </div>
                   <div class="text-danger text-sm formerrors custom_margin" v-show="meetingErr">
                       <vs-alert color="warning" class="warning-alert reg-warning-alert no-border-radius" icon-pack="IntakePortal"
                       icon="IP-information-button" active="true">{{ meetingErr }}</vs-alert>
                   </div>                    
               </div>
               <div class="popup-footer relative">
                   <span class="loader" v-if="loadingRequest" ><img src="@/assets/images/main/loader.gif" /></span>
                   <vs-button color="dark" @click="hideMe()" class="cancel" type="filled">Cancel</vs-button>
                   <vs-button color="success" @click="cancelMeeting()" class="save" type="filled">Submit</vs-button>
               </div>
           </form>
       </div>
       </modal>
    </div>
</template>
<script>
import quillTextEditor from"@/views/forms/fields/quillTextEditor.vue";
import datepickerField from "@/views/forms/fields/datepicker.vue";
import selectField from "@/views/forms/fields/simpleselect.vue";
export default {
    provide() {
        return {
            parentValidator: this.$validator,
        };
    },
    components:{
        selectField,
        datepickerField,
        quillTextEditor
    },
    data: () => ({
        cancelMeatingReason:'',
        loadingRequest:false,
        meetingErr:''
        
    }),
    props:{
        petitionDetails:null,
        callFromEdit:{
            type:Boolean,
            default:false
        },
        i9Id:'',
    },
    methods:{
        hideMe(){
            this.$emit('hideCancelMeeting');
            this.$modal.hide('cancelMeetingModal');
        },
        cancelMeeting(){
            this.$validator.validateAll('meetingForm').then((result)=>{
                if(result){
                    let payLoad ={
                        comment:this.cancelMeatingReason,
                        videoCallId:this.checkProperty(this.petitionDetails, 'videoCallDetails', '_id')
                    }
                    // payLoad['i9Id'] = this.i9Id;
                    // let path = '/i9/cancel-meeting';
                    let path = '/video-call/cancel'
                    this.loadingRequest = true;
                    this.$store.dispatch('commonAction', {data:payLoad, 'path':path}).then((res)=>{
                        this.loadingRequest = false;
                        this.showToster({message:res.message ,isError:false});
                        this.hideMe();
                    }).catch((err)=>{
                        this.loadingRequest = false;
                        this.meetingErr = err;
                    })
                }
            })
        },

    },
    mounted(){
        this.$modal.show('cancelMeetingModal');
    }
}
</script>